<template>
    <div class="farmingon1-slide column-slide">
        <swiper class="swiper" :options="swiperOptions">
            <swiper-slide v-for="(image, index) in images" :key="index">
                <v-card rounded="" class="square-img-card" @click="openDialog(index)">
                    <div class="square-img" :style="'background-image:url(' + image.img + ');'" />
                </v-card>
            </swiper-slide>
            <div class="swiper-control" slot="pagination" @click.prevent>
                <div class="swiper-button-prev" slot="button-prev"><icon-arrow-rounded /></div>
                <div class="swiper-button-next" slot="button-next"><icon-arrow-rounded direction="right" /></div>
            </div>
        </swiper>

        <u-dialog v-model="dialogOpen" eager width="800" overlay-opacity="0.9" content-class="dialog-slide">
            <div class="swiper-dialog">
                <swiper ref="swiperDialog" :options="swiperDialogOptions">
                    <swiper-slide v-for="(image, index) in images" :key="index">
                        <img :src="image.img" class="swiper-dialog__img" />
                    </swiper-slide>
                    <div class="swiper-control" slot="pagination" @click.prevent>
                        <div class="swiper-button-prev"><icon-arrow-rounded /></div>
                        <div class="swiper-button-next"><icon-arrow-rounded direction="right" /></div>
                    </div>
                </swiper>
            </div>
        </u-dialog>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";
import UDialog from "@/components/dumb/u-dialog.vue";

export default {
    props: {},
    components: {
        Swiper,
        SwiperSlide,
        IconArrowRounded,
        UDialog,
    },
    data: () => {
        return {
            swiperOptions: {
                allowTouchMove: true,
                slidesPerView: 2,
                slidesPerColumn: 2,
                slidesPerColumnFill: "row",
                slidesPerGroup: 2,
                spaceBetween: 10,
                speed: 500,
                centeredSlides: false,
                loop: false,
                navigation: {
                    nextEl: ".farmingon1-slide .swiper-button-next",
                    prevEl: ".farmingon1-slide .swiper-button-prev",
                },
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 12,
                    },
                    992: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 24,
                    },
                },
            },

            dialogOpen: false,
            selectedImageIndex: 0,
            swiperDialogOptions: {
                loop: false,
                speed: 500,
                navigation: {
                    nextEl: ".swiper-dialog .swiper-button-next",
                    prevEl: ".swiper-dialog .swiper-button-prev",
                },
            },
            images: [
                { img: "/images/sub/portfolio/farmingon1-slide-img.jpg" },
                { img: "/images/sub/portfolio/farmingon1-slide-img2.jpg" },
                { img: "/images/sub/portfolio/farmingon1-slide-img3.jpg" },
                { img: "/images/sub/portfolio/farmingon1-slide-img4.jpg" },
                { img: "/images/sub/portfolio/farmingon1-slide-img5.jpg" },
                { img: "/images/sub/portfolio/farmingon1-slide-img6.jpg" },
                { img: "/images/sub/portfolio/farmingon1-slide-img7.jpg" },
                { img: "/images/sub/portfolio/farmingon1-slide-img8.jpg" },
            ],
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiperDialog.$swiper;
        },
    },
    mounted() {
    },
    methods: {
        openDialog(index) {
            this.$nextTick(() => {
                // 이미지를 클릭하면 해당 이미지의 인덱스를 설정하고, 모달 창을 엽니다.
                this.selectedImageIndex = index;
                this.dialogOpen = true;
                // Swiper 슬라이드 인덱스를 선택한 이미지의 인덱스로 설정합니다.
                this.swiper.slideTo(index);
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
